import { CHANGE_THEME } from "../../components/administration/actions";

export default {
  settings: {
    CHANGE_THEME,
  },
};
